import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'
import {
    DocumentLevel,
    DocumentStatusFilter,
    TypeDocument,
} from '../../../types/utils'

interface FiltersProps {
    control: Control<any>
    showStatusFilter?: boolean
}

const Filters: React.FC<FiltersProps> = ({ control, showStatusFilter }) => {
    const { t } = useTranslation()
    return (
        <>
            <FormItem
                control={control}
                name="document_type"
                type="select"
                multiple
                label={t('document_type')}
                placeholder={t('document_type')}
                options={TypeDocument(t)}
            />
            <FormItem
                control={control}
                name="document_level"
                type="select"
                multiple
                label={t('document_level')}
                placeholder={t('document_level')}
                options={DocumentLevel(t)}
            />
            <EmployeeSelect
                control={control}
                name="employee_id"
                multiple
                label={t('document_owner')}
            />
            <FormItem
                control={control}
                name="start_day"
                type="daterangepicker"
                label={t('start_day')}
                placeholder={t('start_day')}
            />
            <FormItem
                control={control}
                name="end_day"
                type="daterangepicker"
                label={t('end_day')}
                placeholder={t('end_day')}
            />
            {showStatusFilter && (
                <FormItem
                    control={control}
                    name="status"
                    type="select"
                    label={t('status')}
                    placeholder={t('status')}
                    options={DocumentStatusFilter}
                />
            )}
        </>
    )
}

export default Filters
